import React from 'react';
import { NavigationItem } from '@client/components/navigation/NavigationItem';
import { connect } from 'react-redux';
import { selectUserPermissions } from '@client/redux/user/userReducer';
import { Map } from 'immutable';
import { getProfileRoutes } from '@client/pages/profilePage/routesProfile';

const AuthenticatedRoutesMobile = ({ userPermissions }) => {
  const restrictions = Map({
    shouldBeLoggedIn: true,
    permissions: userPermissions,
  });

  const profileRoutes = getProfileRoutes(restrictions);

  const showProfileNavItem =
    profileRoutes?.ACCOUNT?.ROUTES?.PROFILE?.ROUTES?.INFORMATION;

  const authenticatedRoutesMobile = [
    {
      name: 'Hitta insamlingar',
      path: '/insamlingar/',
    },
    {
      name: 'Frågor och svar',
      path: '/hjalp/',
    },
    {
      name: 'Mina insamlingar',
      path: '/mitt-konto/mina-insamlingar/',
    },
    ...(showProfileNavItem
      ? [
          {
            name: 'Profil',
            path: '/mitt-konto/profil/mina-uppgifter/',
          },
        ]
      : []),
    {
      name: 'Skapa insamling',
      path: '/skapa/insamling/',
    },
  ];

  return (
    <>
      {authenticatedRoutesMobile?.map((navItem) => (
        <NavigationItem
          key={navItem?.path}
          path={navItem?.path}
          name={navItem?.name}
        />
      ))}
    </>
  );
};

function mapStateToProps(state) {
  return {
    userPermissions: selectUserPermissions(state),
  };
}
export default connect(mapStateToProps)(AuthenticatedRoutesMobile);
